module.exports = __webpack_public_path__ + "assets/images/USDUNFIT2.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDUNFIT2.png
// module id = 1468
// module chunks = 1